module.exports = __webpack_public_path__ + "img/UserIcon.913da135.png";